import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TonConnect').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'start',
    width: '100%',
    height: '100vh',
    backgroundColor: 'black',
    zIndex: '1',

    h1: {
      fontSize: theme.sizes.texts.fontSize.xl,

      fontWeight: '600',
      lineHeight: '40px',
      margin: '0',
      color: theme.colors.text.primary,
    },

    p: {
      margin: '0',
      fontSize: theme.sizes.texts.fontSize.m,
      fontWeight: '450',
      lineHeight: theme.sizes.texts.lineHeight.xl,
    },
  },

  logo: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '115px',
    gap: '12px',
    color: theme.colors.text.primary,
    zIndex: '1',

    img: {
      width: '100%',
      height: '100%',
    },

    '&:before': {
      content: '""',
      width: '50%',
      aspectRatio: '1/1',
      borderRadius: '50%',
      backgroundColor: '#9CDAFF40',
      position: 'absolute',
      bottom: '-50px',
      zIndex: '-99',
      filter: 'blur(30px)',
    },

    '&:after': {
      content: '""',
      width: '100%',
      aspectRatio: '1/1',
      borderRadius: '50%',
      backgroundColor: '#2153C7B2',
      position: 'absolute',
      bottom: '-120px',
      zIndex: '-99',
      filter: 'blur(90px)',
    },
  },

  content: {
    position: 'relative',
    bottom: '10vh',
    backgroundColor: theme.colors.background.primary,
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    gap: '12px',
    zIndex: '1',
  },

  title: {
    alignSelf: 'flex-start',
    textAlign: 'left',
    color: theme.colors.text.primary,
    fontFamily: 'Inter',
    fontWeight: '550',
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,
  },
  text: {
    alignSelf: 'flex-start',
    textAlign: 'left',
    fontFamily: 'Inter',
    fontWeight: '450',
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    color: theme.colors.text.secondary,
  },

  buttonText: {
    fontFamily: 'Inter',
    fontWeight: '560',
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
    cursor: 'pointer',
  },

  buttonTextsecond: {
    textTransform: 'uppercase',
    fontFamily: 'Inter',
    fontWeight: '470',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
  },
}))
